<div class="center-stage">
  <app-folding-cube></app-folding-cube>
</div>
